import React, { useRef } from "react";

import style from "../assets/css/components/Sponsors.module.css";
import Carousel from "react-elastic-carousel";

import img1 from "../assets/img/sponsor2.png";
import img2 from "../assets/img/sponsor.png";

function Sponsors() {
  const carouselRef = useRef();

  const totalPages = 2;
  let resetTimeout;

  return (
    <div className={style.contCarousel}>
      <Carousel
        className={style.carousel}
        pagination={false}
        showArrows={false}
        ref={carouselRef}
        enableAutoPlay
        autoPlaySpeed={5000} // same time
        onNextEnd={({ index }) => {
          clearTimeout(resetTimeout);
          if (index + 1 === totalPages) {
            resetTimeout = setTimeout(() => {
              if (carouselRef?.current?.goTo) {
                carouselRef.current.goTo(0);
              }
            }, 5000); // same time
          }
        }}
      >
        <Image img={img1} />
        <Image img={img2} />
      </Carousel>
    </div>
  );
}

const Image = ({ img }) => (
  <div className={style.contImage}>
    <img className={style.image} src={img} alt="" />
  </div>
);

export default Sponsors;
